import { OnlineDot } from "@/components/OnlineDot";

export function ThreadList({ threads, activeId, onSelect }) {
  return (
    <div className="bg-white border border-border rounded-sm overflow-y-auto">
      {threads.map((t) => (
        <button key={t.thread_id} data-testid={`thread-${t.partner_id}`} onClick={() => onSelect(t)}
          className={`w-full text-left p-4 border-b border-border hover:bg-slate-50 ${activeId === t.partner_id ? "bg-primary/5" : ""}`}>
          <div className="font-semibold text-sm flex items-center gap-2">{t.partner_name} <span className="text-xs text-muted-foreground">· {t.partner_role}</span> <OnlineDot online={t.partner_online} showLabel={false} /></div>
          <div className="text-xs text-muted-foreground truncate">{t.last_message || "No messages yet"}</div>
        </button>
      ))}
    </div>
  );
}
